{
	"ariaAccount": "Account",
	"ariaHome": "home",
	"beta": "Beta",
	"continue": "Continue",
	"installDesktopApp": "Install Desktop App",
	"learnMore": "Learn More",
	"logOut": "Log Out",
	"navAiStyles": "AI Styles",
	"navProjects": "Projects",
	"navSettings": "Settings",
	"navTutorials": "Tutorials",
	"sunsetMessageActive": "We're transitioning to Pixieset Photo Editor! As an early supporter, you have early access to use Pixieset Photo Editor. Learn more about Pixieset Photo Editor, how to migrate your AI Styles and Projects, and refunds for your subscriptions.",
	"sunsetMessageInactive": "As we transition this experience to Pixieset Photo Editor, Polarr Next will no longer be available after October 13, 2026. The app will remain available until then so you can back up your work. Learn more about this change and Pixieset Photo Editor.",
	"sunsetTitle": "Polarr Next will shut down on October 13, 2026.",
	"unlimited": "Unlimited",
	"userExports": "{{count}} exports",
	"welcomeDescription": "Get fast, consistent edits in your signature style—with Smart Editing and Culling powered by AI.",
	"welcomeTitle": "Welcome to {{productName}}"
}
